import React, { Component } from 'react';
import Grid from '../common/layout/grid';
import TooltipWrapper from '../common/form/TooltipWrapper';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from '../common/form/button';
import { testarConexao, reset, enviarRelogioControlador, getSincronizacao } from './controladorActions';
import { toastr } from 'react-redux-toastr';
import ReactLoading from 'react-loading';
import { Modal } from 'react-bootstrap';
import PermissaoUsuario from '../auth/permissao';
import { Field } from 'redux-form';
import labelAndInput from '../common/form/labelAndInput';
import swal from 'sweetalert2';

// import { StatusCon } from './status';

class ControladorConexao extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
    };

    // Controla se foi realizado teste manual para não sobrescrever o resultado
    this.testeManualRealizado = false;
  }

  handleClose() {
    this.setState({ show: false });
  }

  getConexao(enderecoUDP) {
    window.$('#versaoMCPControlador').val('Conectando...');

    // Busca dados mais recentes do banco antes de testar
    this.buscarDadosSincronizacao();

    this.props
      .testarConexao(enderecoUDP, this.props.numCont)
      .then(result => {
        // Atualiza versão MCP
        window.$('#versaoMCPControlador').val(result.payload.data.versao_mcp);

        // Move o valor atual para o campo anterior (se houver)
        const valorAtualAnterior = window.$('#dataHoraAtual').val();
        if (
          valorAtualAnterior &&
          valorAtualAnterior !== 'Clique em "Testar Conexão"' &&
          valorAtualAnterior !== 'Sem conexão'
        ) {
          window.$('#dataHoraAnterior').val(valorAtualAnterior);
        }

        // Atualiza Data/Hora Última Verificação com a hora lida do controlador no teste
        const dataHoraAtual = result.payload.data.data + '  ' + result.payload.data.hora;
        window.$('#dataHoraAtual').val(dataHoraAtual);
        window.$('#dataHoraAtual').css('background-color', '#d4edda'); // Verde claro para indicar sucesso

        // Marca que foi realizado teste manual
        this.testeManualRealizado = true;

        window.$('#btnTestarConexao').removeClass('btn-default');
        window.$('#btnTestarConexao').removeClass('btn-warning');
        window.$('#btnTestarConexao').addClass('btn-success');
        window.$('#statusConexaoCont').html('<b>Status:</b> Online');

        if (result.payload.data.porta_enviada !== result.payload.data.porta_controlador) {
          toastr.warning(
            'Alerta',
            'A porta enviada ' +
              result.payload.data.porta_enviada +
              ' não confere com a porta ' +
              result.payload.data.porta_controlador +
              ' encontrada no controlador. Será alterado automaticamente.',
          );

          this.props.change('porta', result.payload.data.porta_controlador);
        }

        // dispatch([
        //     { type: 'CONEXAO_CONTROLE', dataHora: resp.data, conectado: true }
        // ])
      })
      .catch(e => {
        window.$('#versaoMCPControlador').val('Sem conexão');
        window.$('#dataHoraAtual').val('Sem conexão');
        window.$('#dataHoraAtual').css('background-color', '#f8d7da'); // Vermelho claro para erro
        window.$('#statusConexaoCont').html('<b>Status:</b> Offline');

        window.$('#btnTestarConexao').removeClass('btn-default');
        window.$('#btnTestarConexao').removeClass('btn-success');
        window.$('#btnTestarConexao').addClass('btn-warning');
        toastr.error('Erro', 'Sem conexão. O número ou endereço do controlador podem estar errados.');
        // e.response.data.errors.forEach(
        //     error => toastr.error('Erro', error))
      });
  }

  // Busca dados de sincronização automática - atualiza apenas Data/Hora Anterior
  buscarDadosSincronizacao() {
    if (this.props.controladorId) {
      getSincronizacao(this.props.controladorId)
        .then(response => {
          const sincronizacao = response.data;

          // Atualiza campo de verificação anterior (penúltimo registro)
          if (sincronizacao.anterior && sincronizacao.anterior.dataHora) {
            window.$('#dataHoraAnterior').val(sincronizacao.anterior.dataHora);
          } else {
            window.$('#dataHoraAnterior').val('Nenhum registro');
          }

          // Atualiza campo de última verificação (último registro) apenas se não foi teste manual
          if (sincronizacao.ultimo && sincronizacao.ultimo.dataHora && !this.testeManualRealizado) {
            window.$('#dataHoraAtual').val(sincronizacao.ultimo.dataHora);
            window.$('#dataHoraAtual').css('background-color', '#e2e3e5'); // Cinza claro para automático
          }
        })
        .catch(error => {
          console.error('Erro ao buscar dados de sincronização:', error);
          window.$('#dataHoraAnterior').val('Erro ao carregar');
        });
    } else {
      // Se não tem controladorId, limpa o campo
      window.$('#dataHoraAnterior').val('Selecione um controlador');
    }
  }

  // Método chamado quando o componente é montado
  componentDidMount() {
    // Inicializa campos
    if (this.props.controladorId) {
      window.$('#dataHoraAnterior').val('Carregando...');
      window.$('#dataHoraAtual').val('Carregando...');
      window.$('#dataHoraAtual').css('background-color', '#e2e3e5'); // Cinza claro

      // Busca dados de sincronização
      this.buscarDadosSincronizacao();
    } else {
      window.$('#dataHoraAnterior').val('Selecione um controlador');
      window.$('#dataHoraAtual').val('Selecione um controlador');
      window.$('#dataHoraAtual').css('background-color', '#e2e3e5');
    }

    // Atualiza dados a cada 30 segundos
    this.intervalId = setInterval(() => {
      this.buscarDadosSincronizacao();
    }, 30000);
  }

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  componentDidUpdate(prevProps) {
    // Se o controlador mudou, busca novos dados e limpa campos
    if (prevProps.controladorId !== this.props.controladorId) {
      // Reseta flag de teste manual
      this.testeManualRealizado = false;

      if (this.props.controladorId) {
        // Limpa os campos antes de buscar novos dados
        window.$('#dataHoraAnterior').val('Carregando...');
        window.$('#dataHoraAtual').val('Carregando...');
        window.$('#dataHoraAtual').css('background-color', '#e2e3e5');

        this.buscarDadosSincronizacao();
      } else {
        window.$('#dataHoraAnterior').val('Selecione um controlador');
        window.$('#dataHoraAtual').val('Selecione um controlador');
        window.$('#dataHoraAtual').css('background-color', '#e2e3e5');
      }
    }
  }

  reset(enderecoUDP) {
    swal({
      title: '<h3 style="color:red">Atenção</h3>',
      html: '<h4>Deseja resetar o controlador?</h4>',
      type: 'alert',
      width: '520px',
      heightAuto: false,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'OK',
      cancelButtonColor: '#f39c12',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: false,
      timer: 30000,
    }).then(response => {
      if (response.value) {
        this.setState({ show: true });
        this.props
          .reset(enderecoUDP, this.props.numCont)
          .then(result => {
            this.setState({ show: false });
            toastr.success('Sucesso!', result.payload.data);
          })
          .catch(e => {
            this.setState({ show: false });
            toastr.error('Erro', 'Sem conexão. O número ou endereço do controlador podem estar errados.');
          });
      }
    });
  }

  enviarRelogio(enderecoUDP) {
    this.setState({ show: true });

    this.props
      .enviarRelogioControlador(enderecoUDP, this.props.numCont)
      .then(result => {
        this.setState({ show: false });

        if (result.error) {
          toastr.error('Erro', result.payload.response.data.errors[0]);
        } else {
          toastr.success('Sucesso', 'Operação Realizada com sucesso.');

          // Após sucesso no envio da data/hora, executa teste de conexão automaticamente
          // para atualizar o campo "Data/Hora Última Verificação"
          setTimeout(() => {
            this.getConexao(enderecoUDP);
          }, 1000); // Aguarda 1 segundo para garantir que o controlador processou a nova hora
        }
      })
      .catch(e => {
        this.setState({ show: false });
        toastr.error('Erro', e);
      });
  }

  render() {
    const enderecoUDP = this.props.udp || [];

    return (
      <>
        <Modal show={this.state.show} onHide={this.handleClose} dialogClassName="modal-load" backdrop={false}>
          <Modal.Body className="modal-body modal-load-body">
            <div>
              <div>
                <ReactLoading className="react-loading" type="spokes" color="#367fa9" height={50} width={50} />
              </div>
              <div>
                <h4>
                  <b>Aguarde, processando...</b>
                </h4>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Field
          name="ip"
          component={labelAndInput}
          ref="controladorip"
          label="IP do Controlador*"
          cols="12 4"
          placeholder="Informe o IP"
          validate={this.props.required}
          readOnly={this.props.readOnly('CadControlador', 'ip_porta_controlador')}
        />

        <Field
          name="porta"
          id="porta"
          component={labelAndInput}
          label="Porta do Controlador*"
          cols="12 4"
          placeholder="Informe a porta"
          validate={this.props.required}
          readOnly={this.props.readOnly('CadControlador', 'ip_porta_controlador')}
        />

        <div className="col-xs-12 col-sm-2">
          <div className="form-group form-group-sm">
            <label className="label-gt" id="statusConexaoCont">
              Status:
            </label>

            <PermissaoUsuario tela="CadControlador" campo="testar_conexao" condicao={true}>
              <Button
                type="button"
                id="btnTestarConexao"
                className="primary form-control"
                icon="plug"
                label="Testar Conexão"
                onClick={() => this.getConexao(enderecoUDP)}
              />
            </PermissaoUsuario>

            <PermissaoUsuario tela="CadControlador" campo="testar_conexao" condicao={false}>
              <Button
                type="button"
                id="btnTestarConexao"
                className="primary form-control"
                icon="plug"
                label="Testar Conexão"
                disabled="disabled"
              />
            </PermissaoUsuario>
          </div>
        </div>

        <div className="col-xs-12 col-sm-2">
          <div className="form-group form-group-sm">
            <div>
              <b>&nbsp;</b>
            </div>
            <PermissaoUsuario tela="CadControlador" campo="resetar_controlador" condicao={true}>
              <Button
                type="button"
                id="btnResetar"
                className="danger form-control"
                icon="power-off"
                label="Resetar"
                onClick={() => this.reset(enderecoUDP)}
              />
            </PermissaoUsuario>

            <PermissaoUsuario tela="CadControlador" campo="resetar_controlador" condicao={false}>
              <Button
                type="button"
                id="btnResetar"
                className="danger form-control"
                icon="power-off"
                label="Resetar"
                disabled="disabled"
              />
            </PermissaoUsuario>
          </div>
        </div>

        <Field
          name="dataHoraAnterior"
          id="dataHoraAnterior"
          component={labelAndInput}
          label={
            <TooltipWrapper tooltipText="Penúltima verificação realizada pela central (5 minutos atrás)">
              <span>
                Data/Hora <small style={{ fontWeight: '600' }}>Verificação Anterior</small>
              </span>
            </TooltipWrapper>
          }
          tooltipText="Atualizado automaticamente pela central a cada 5 minutos"
          uncontrolledWhenReadOnly={true}
          cols="6 3"
          readOnly={true}
        />
        <Field
          name="dataHoraAtual"
          id="dataHoraAtual"
          component={labelAndInput}
          label={
            <TooltipWrapper tooltipText="Última verificação realizada pela central (5 minutos atrás) ou teste manual">
              <span>
                Data/Hora <small style={{ fontWeight: '600' }}>Última Verificação</small>
              </span>
            </TooltipWrapper>
          }
          uncontrolledWhenReadOnly={true}
          cols="6 3"
          readOnly={true}
        />
        <Field
          name="versaoMCPControlador"
          id="versaoMCPControlador"
          component={labelAndInput}
          label="Versão da MCP"
          uncontrolledWhenReadOnly={true}
          cols="6 3"
          readOnly={true}
        />

        <div className="col-xs-12 col-sm-3">
          <div className="form-group form-group-sm">
            <div>
              <b>&nbsp;</b>
            </div>
            <PermissaoUsuario tela="CadControlador" campo="enviar_relogio" condicao={true}>
              <Button
                type="button"
                id="btnEnviarRelogioControlador"
                className="primary form-control"
                icon="arrow-up"
                label="Enviar Data/Hora"
                onClick={() => this.enviarRelogio(enderecoUDP)}
              />
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadControlador" campo="enviar_relogio" condicao={false}>
              <Button
                type="button"
                id="btnEnviarRelogioControlador"
                className="primary form-control"
                icon="arrow-up"
                label="Enviar Data/Hora"
                disabled="disabled"
              />
            </PermissaoUsuario>
          </div>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ testarConexao, reset, enviarRelogioControlador }, dispatch);
export default connect(
  null,
  mapDispatchToProps,
)(ControladorConexao);

//export default ControladorConexao;
